import APIClient from '@/shared/http/clients/api'

const resourceName = 'empresa'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllPagingFiltro = (limit, index, busca, selecionavel, config = {}) => {
  const params = { limit, index }
  if (busca) params.busca = busca
  if (selecionavel !== null && selecionavel !== undefined) params.selecionavel = selecionavel
  return APIClient.get(`${APICore}/${resourceName}`, { ...config, params })
}
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const GetSelecionaveis = (config = {}) => APIClient.get(`${APICore}/${resourceName}/selecionaveis`, config)
const GetByCodigo = (codigo, config = {}) => APIClient.get(`${APICore}/${resourceName}/codigo/${codigo}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const CompanyRepository = {
  GetAll,
  GetAllPaging,
  GetAllPagingFiltro,
  GetById,
  GetSelecionaveis,
  GetByCodigo,
  Create,
  Update,
  Delete
}

export default CompanyRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/company.js